import React from 'react'
import { Route } from 'react-router-dom'
import { ConnectedSwitch } from 'reactRouterConnected'
import Loadable from 'react-loadable'
import Page from 'components/LayoutComponents/Page'
import NotFoundPage from 'pages/DefaultPages/NotFoundPage'
import HomePage from 'pages/DefaultPages/HomePage'

const loadable = loader =>
  Loadable({
    loader,
    delay: false,
    loading: () => null,
  })

const loadableRoutes = {
  // Default Pages
  '/login': {
    component: loadable(() => import('pages/DefaultPages/LoginPage')),
  },
  '/Download': {
    component: loadable(() => import('pages/DefaultPages/Download')),
  },
  '/changePassword': {
    component: loadable(() => import('pages/DefaultPages/ChangePassword')),
  },
  '/empty': {
    component: loadable(() => import('pages/DefaultPages/EmptyPage')),
  },
  '/admin/DashboardTling': {
    component: loadable(() => import('pages/Dashboard/DashboardTling')),
  },
  '/admin/PowerBI': {
    component: loadable(() => import('pages/Dashboard/PowerBI')),
  },
  '/admin/SurveysAdmin': {
    component: loadable(() => import('pages/Dashboard/SurveysAdmin')),
  },
  '/admin/DashboardSurveys/:createdAt/:kaizalaId/:actionId': {
    component: loadable(() => import('pages/Dashboard/DashboardSurveys')),
  },
  '/admin/CreateSurvey/:typeCamping/:idCampaing': {
    component: loadable(() => import('pages/Dashboard/SurveysAdmin/CreateSurvey')),
  },
  '/admin/users': {
    component: loadable(() => import('pages/Dashboard/users')),
  },
  '/admin/users/categories': {
    component: loadable(() => import('pages/Dashboard/users/categories')),
  },
  '/admin/Payments': {
    component: loadable(() => import('pages/Dashboard/Payments')),
  },
  '/admin/Groups': {
    component: loadable(() => import('pages/Dashboard/Groups')),
  },
  '/admin/GroupsDetail/:kaizalaId': {
    component: loadable(() => import('pages/Dashboard/DetailGroup')),
  },
  '/admin/CreateGroup': {
    component: loadable(() => import('pages/Dashboard/CreateGroup')),
  },
  '/admin/Suppliers': {
    component: loadable(() => import('pages/Dashboard/Suppliers')),
  },
  '/admin/CreateSuppliers': {
    component: loadable(() => import('pages/Dashboard/Suppliers/CreateSuppliers')),
  },
  '/admin/Division': {
    component: loadable(() => import('pages/Dashboard/Division')),
  },
  '/admin/Setings': {
    component: loadable(() => import('pages/Dashboard/Setings')),
  },
  '/admin/templates': {
    component: loadable(() => import('pages/Dashboard/Templates')),
  },
  '/admin/SavedCampaigns': {
    component: loadable(() => import('pages/Dashboard/SavedCampaigns')),
  },
  '/admin/scheduledCampaigns': {
    component: loadable(() => import('pages/Dashboard/scheduledCampaigns')),
  },
  '/admin/redeemPoints': {
    component: loadable(() => import('pages/Dashboard/redeemPoints')),
  },
}

class Routes extends React.Component {
  timeoutId = null

  componentDidMount() {
    this.timeoutId = setTimeout(
      () => Object.keys(loadableRoutes).forEach(path => loadableRoutes[path].component.preload()),
      5000, // load after 5 sec
    )
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  render() {
    return (
      <ConnectedSwitch>
        <Route exact path="/" component={HomePage} />
        {Object.keys(loadableRoutes).map(path => {
          const { exact, ...props } = loadableRoutes[path]
          props.exact = exact === void 0 || exact || false // set true as default
          return <Route key={path} path={path} {...props} />
        })}
        <Route
          render={() => (
            <Page>
              <NotFoundPage />
            </Page>
          )}
        />
      </ConnectedSwitch>
    )
  }
}

export { loadableRoutes }
export default Routes



// WEBPACK FOOTER //
// ./src/routes.js